module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticStyle: {
      "max-width": "270px"
    },
    attrs: {
      "id": "sidebar-container"
    }
  }, [_c('sidebar-menu', {
    attrs: {
      "menu": _vm.menu,
      "collapsed": _vm.collapsed,
      "theme": _vm.selectedTheme,
      "show-one-child": true
    },
    on: {
      "toggle-collapse": _vm.onToggleCollapse,
      "item-click": _vm.onItemClick
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b02cb45a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/postulante/panelView.vue
// module id = 662
// module chunks = 1